export const rootsValues = {
  GUM: "GUM",
  ROOTS: "ROOTS",
  ROOTS_BONES: "ROOTS_BONES",
};
